import { AppConfig } from './../app.config';
import { SnapshotService } from './../snapshot/snapshot.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { Projection, Correction, CurrencyUtil } from '@liquitics/transaction';
import { CorrectionService } from './correction.service';
import { CommunicationService } from '../common/communication.service';


@Component({
    selector: 'app-correction',
    templateUrl: './correction.component.html',
    styleUrls: ['./correction.component.css']
})
export class CorrectionComponent implements OnInit {
    currencies: string[];
    clientGroups: string[] = [];
    productTypes: string[] = [];
    submitResult: string;
    minimumCorrectionAmount = -10000000000;
    maximumCorrectionAmount = 10000000000;

    correctionFormGroup: FormGroup;

    constructor( @Inject(MAT_DIALOG_DATA) public data: any,
        private appConfig: AppConfig,
        private snapshotService: SnapshotService,
        private correctionService: CorrectionService,
        private communicationService: CommunicationService) {
        this.currencies = appConfig.activeUserProfile.getCurrencies();
        this.clientGroups = snapshotService.applicationConfiguration.clientGroups;
        this.productTypes = snapshotService.applicationConfiguration.productTypes;
    }

    ngOnInit() {
        this.correctionFormGroup = new FormGroup({
            'currency': new FormControl(this.data.correction.currency, [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(3),
                currencyValidator(this.currencies),
            ]
            ),
            'clientGroup': new FormControl(this.data.correction.projectionUpdateClientGroup, [
                Validators.required,
            ]
            ),
            'productType': new FormControl(this.data.correction.projectionUpdateProductType, [
                Validators.required,
            ]
            ),
            'changeReason': new FormControl(this.data.correction.changeReason, [
                Validators.required,
            ]
            ),
        });
    }

    submit() {
        this.correctionService
            .saveCorrection(this.data.correction)
            .then(() => {
                this.communicationService.openSnackBar('Submission Successful', 'Ok');
            })
            .catch((err: any) => {
                this.communicationService.openSnackBar('Submission Failed', 'Dismiss');
            })
            ;

    }

    get currency() {
        return this.correctionFormGroup.get('currency');
    }

    get clientGroup() {
        return this.correctionFormGroup.get('clientGroup');
    }

    get productType() {
        return this.correctionFormGroup.get('productType');
    }

    get changeReason() {
        return this.correctionFormGroup.get('changeReason');
    }

    updateCorrectionAmount(event: string) {
        const amount = parseFloat(event);
        this.data.correction.amount = amount;
    }

    projectionUpdateProductTypeSelected(event) {
        const correction: Correction = this.data.correction;
        const projections: Projection[] = this.snapshotService
            .getProjections(correction.currency, correction.projectionUpdateClientGroup, correction.direction);
        const totalProjectedAmount = projections.filter((projection: Projection) => {
            return projection.productType === correction.projectionUpdateProductType;
        })
            .reduce((amount: number, p: Projection) => {
                return amount + p.amount;
            }, 0);
        correction.projectionUpdateOriginalAmount = totalProjectedAmount;
    }
}

export function currencyValidator(currencies: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const isValid = currencies.includes(String(control.value).toUpperCase());
        return !isValid ? { 'invalidCurrency': { value: control.value } } : null;
    };
}

